/* eslint-disable array-callback-return */
import React, { Component } from 'react'
import "./css/Score.css";
import { HOST } from './../../config';

export default class Score extends Component {
    constructor (props) {
        super(props);
        this.state = {
            SCORE: null,
            SelectYear: null,
            ScoreCourse: null,
            ScoreSemester: null,

            showMark: false,
            ESTIMATION: null,
            ERROR: null,
            ESTIMATIONfetch: null,
            ESTIMATIONcurrent: null,
            ESTIMATIONattr: null,
            DETAILvalue: null,
            DETAILname: null,
            DETAILfetch: false,
        };
    }

    componentDidMount() {
        let ScoreByYear = this.props.SCORE.reduce(function (r, a) {
            r[a.id_a_year] = r[a.id_a_year] || [];
            r[a.id_a_year].push(a);
            return r;
        }, Object.create(null));

        let ScoreByYearArray = Object.keys(ScoreByYear).map((key) => [Number(key), ScoreByYear[key]]);
        this.setState({
            SCORE: ScoreByYearArray
        });
        setTimeout(() => {
            //first render
            let currentIndex = ScoreByYearArray.findIndex(x => x[0] == this.props.YEAR);
            //if not found get first item
            currentIndex = currentIndex != -1 ? currentIndex : 0;
            this.semester(currentIndex);
        }, 0)

    }
    groupByKey = (list, key, { omitKey = false }) =>
        list.reduce(
            (hash, { [key]: value, ...rest }) => ({
                ...hash,
                [value]: (hash[value] || []).concat(
                    omitKey ? { ...rest } : { [key]: value, ...rest }
                ),
            }),
            {}
        );
    // /personalcard modal 
    toggleMark = () => { this.setState({ showMark: !this.state.showMark }); }

    handleChangeMark = (event) => {
        const est = event.target.options[event.target.selectedIndex].dataset.id;
        this.markDetail(...this.state.ESTIMATIONattr, est);
    }

    markDetail = (year, semester, discipline, credit, student, group, est) => {
        this.setState({ DETAILfetch: true, });
        fetch(`${HOST}/markdetail.json`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ year, semester, discipline, credit, id: student, group, est })
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.error) {
                    this.setState({
                        DETAILvalue: null,
                        DETAILname: null,
                        ERROR: "Ошибка не найдено!",
                        DETAILfetch: false,
                    });
                } else {
                    this.setState({
                        DETAILvalue: json.data[0][0],
                        DETAILname: json.data[1],
                        DETAILfetch: false,
                    });
                }
            })
    }

    markEst = (year, semester, discipline, credit, student, group, current) => {
        this.setState({ ESTIMATIONfetch: true, });
        fetch(`${HOST}/markest.json`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ year, semester, discipline, credit, id: student, group, })
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.error) {
                    this.setState({
                        ESTIMATION: null,
                        ESTIMATIONattr: null,
                        ERROR: "Ошибка не найдено!",
                        ESTIMATIONfetch: false,
                    });
                } else {
                    if (json.data.length) {
                        this.setState({
                            ESTIMATION: json.data,
                            ESTIMATIONfetch: false,
                            showMark: true,
                            ESTIMATIONcurrent: current,
                            ESTIMATIONattr: [year, semester, discipline, credit, student, group],
                        });
                        this.markDetail(year, semester, discipline, credit, student, group, json.data.slice(-1).pop().id_f_est);
                    }
                    else this.setState({
                        ESTIMATION: null,
                        ERROR: "Ошибка нет записей!",
                        ESTIMATIONfetch: false,
                        ESTIMATIONattr: null,
                    });
                }
            });
    }

    markDetailInfo = () => {
        const { DETAILfetch, DETAILname, DETAILvalue } = this.state
        if (!DETAILfetch && !DETAILvalue) {
            return null
        }
        if (!DETAILfetch && DETAILname.length == 0) {
            // console.log("markDetailInfo 3", !DETAILfetch, DETAILname, DETAILname.length, DETAILname.length == 0);
            return (
                <table>

                    <tr>
                        <th>Форма контроля</th>
                        <td>{this.state.ESTIMATIONcurrent.p30}</td>
                    </tr>
                    <tr>
                        <th>Всего часов</th>
                        <td>{this.state.ESTIMATIONcurrent.p54}</td>
                    </tr>
                    <tr>
                        <th>Кредит</th>
                        <td>{this.state.ESTIMATIONcurrent.Krdt}</td>
                    </tr>
                    <tr>
                        <th>Дата сдачи</th>
                        <td>{this.state.ESTIMATIONcurrent.p36}</td>
                    </tr>
                    <tr>
                        <th>Оценка</th>
                        <td>{this.state.ESTIMATIONcurrent.p31}</td>
                    </tr>
                    <tr>
                        <th>Общий балл</th>
                        <td>{Math.round(this.state.DETAILvalue.ball1 * 100) / 100}</td>
                    </tr>
                </table>
            )
        }
        if (!DETAILfetch && DETAILname.length > 0) {
            // console.log("markDetailInfo 4", !DETAILfetch, DETAILname, DETAILname.length, DETAILname.length > 0);
            return (
                < table >
                    <tr>
                        <th>Форма контроля</th>
                        <td>{this.state.ESTIMATIONcurrent.p30}</td>
                    </tr>
                    <tr>
                        <th>Всего часов</th>
                        <td>{this.state.ESTIMATIONcurrent.p54}</td>
                    </tr>
                    <tr>
                        <th>Кредит</th>
                        <td>{this.state.ESTIMATIONcurrent.Krdt}</td>
                    </tr>
                    <tr>
                        <th>Дата сдачи</th>
                        <td>{this.state.ESTIMATIONcurrent.p36}</td>
                    </tr>
                    <tr>
                        <th>Оценка</th>
                        <td>{this.state.ESTIMATIONcurrent.p31}</td>
                    </tr>

                    {this.state.DETAILname.map(name => {
                        // console.log("markDetailInfo name 1", name, name.name_pole);
                        return <tr style={{ backgroundColor: "#d2e7f4" }}>
                            <th>{name.name_pole}</th>
                            <td> {Math.round((this.state.DETAILvalue[name.pole_mark_mag] * 100) / 100)}</td>
                        </tr>
                    })}
                </table >
            )
        }
    }

    showMarkModal = () => {
        return <div className="markDetailWrapper" id="markDetail"
            onClick={this.toggleMark}>
            <div className="markDetail" onClick={e => e.stopPropagation()} >
                <div className="markDetailClose" >
                    <div id="mdiv" title="Закрыть" style={{ float: "right" }} onClick={this.toggleMark}>
                        <div class="mdiv">
                            <div class="md"></div>
                        </div>
                    </div>
                </div>
                <div className="markDetailSelect" >
                    <select onChange={this.handleChangeMark} style={{
                        width: "50%",
                        border: "1px solid #4967a3",
                        padding: "4px"
                    }}>
                        {
                            this.state.ESTIMATION.map((est, index) => {
                                return (
                                    <option
                                        data-id={est.id_f_est}
                                        selected={!this.state.ESTIMATION[index + 1]}>
                                        {/* selected last item */}
                                        {est.f_est}
                                    </option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="markDetailInfo">
                    <p style={{ color: "#fd7e14" }}>{this.state.ESTIMATIONcurrent.p34}</p>
                    {this.markDetailInfo()}
                </div>
            </div>
        </div>
    }

    /////////////////////////////////////////////
    // change year
    handleChange = (event) => {
        const datasetId = event.target.options[event.target.selectedIndex].dataset.id;
        this.semester(parseInt(datasetId));
    }
    // render 2 semesters
    semester = (index) => {
        const { SCORE } = this.state;
        let semester = Object.entries(
            this.groupByKey(SCORE[index][1], "id_semester", { omitKey: true })
        );

        let ScoreSemester1 = [];
        let ScoreSemester2 = [];
        let ScoreSemester3 = [];
        let ScoreSemester4 = [];

        let ScoreData1 = [];
        let ScoreData2 = [];
        let ScoreData3 = [];
        let ScoreData4 = [];


        let TotalScore1 = [];
        let TotalScore2 = [];
        let TotalScore3 = [];
        let TotalScore4 = [];



        if (semester[0]) {
            // semester name
            ScoreSemester1.push(
                <div className="Score_Sem_M">
                    <p>{semester[0][1][0].p43}</p>
                </div>
            );
            // discipline info
            for (let a = 0; a < semester[0][1].length; a++) {
                ScoreData1.push(
                    <div>
                        <label className="M_Scores"
                            onClick={() => this.markEst(
                                semester[0][1][a].id_a_year,
                                semester[0][0],
                                semester[0][1][a].id_discipline,
                                semester[0][1][a].Krdt,
                                semester[0][1][a].id_student,
                                semester[0][1][a].id_group,
                                semester[0][1][a],
                            )}
                        >
                            <p>
                                {semester[0][1][a].p34}
                                <br />
                                <span>{`[${semester[0][1][a].Krdt} кр.] (${semester[0][1][a].p30} - ${semester[0][1][a].p36})`}</span>
                            </p>
                            <div>
                                <p className="Ball">{`${semester[0][1][a].ball} (${semester[0][1][a].p31})`}</p>
                            </div>
                        </label>
                    </div>
                );
            }
            // Total credit
            let Sum1 = 0;
            for (let a = 0; a < semester[0][1].length; a++) {
                Sum1 = Sum1 + semester[0][1][a].Krdt;
            }
            TotalScore1.push(
                <div className="Total_Score_M">
                    <p >Сумма зарегистрированных кредитов</p>
                    <p>{Sum1} </p>
                </div>
            );
        }
        if (semester[1]) {
            // semester name
            ScoreSemester2.push(
                <div className="Score_Sem_M">
                    <p>{semester[1][1][0].p43}</p>
                </div>
            );
            // discipline info
            for (let b = 0; b < semester[1][1].length; b++) {
                ScoreData2.push(
                    <div>
                        <label className="M_Scores"
                            onClick={() => this.markEst(
                                semester[1][1][b].id_a_year,
                                semester[1][0],
                                semester[1][1][b].id_discipline,
                                semester[1][1][b].Krdt,
                                semester[1][1][b].id_student,
                                semester[1][1][b].id_group,
                                semester[1][1][b],
                            )}
                        >
                            <p >
                                {semester[1][1][b].p34}
                                <br />
                                <span>{`[${semester[1][1][b].Krdt} кр.] (${semester[1][1][b].p30} - ${semester[1][1][b].p36})`}</span>
                            </p>
                            <div>
                                <p className="Ball">{`${semester[1][1][b].ball} (${semester[1][1][b].p31})`}</p>
                            </div>
                        </label>
                    </div>
                );
            }
            // Total credit
            let Sum2 = 0;
            for (let a = 0; a < semester[1][1].length; a++) {
                Sum2 = Sum2 + semester[1][1][a].Krdt;
            }
            TotalScore2.push(
                <div className="Total_Score_M">
                    <p >Сумма зарегистрированных кредитов</p>
                    <p>{Sum2} </p>
                </div>
            );
        }
        if (semester[2]) {
            // semester name
            ScoreSemester3.push(
                <div className="Score_Sem_M">
                    <p>{semester[2][1][0].p43}</p>
                </div>
            );
            // discipline info
            for (let b = 0; b < semester[2][1].length; b++) {
                ScoreData3.push(
                    <div>
                        <label className="M_Scores"
                            onClick={() => this.markEst(
                                semester[2][1][b].id_a_year,
                                semester[2][0],
                                semester[2][1][b].id_discipline,
                                semester[2][1][b].Krdt,
                                semester[2][1][b].id_student,
                                semester[2][1][b].id_group,
                                semester[2][1][b],
                            )}
                        >
                            <p >
                                {semester[2][1][b].p34}
                                <br />
                                <span>{`[${semester[2][1][b].Krdt} кр.] (${semester[2][1][b].p30} - ${semester[2][1][b].p36})`}</span>
                            </p>
                            <div>
                                <p className="Ball">{`${semester[2][1][b].ball} (${semester[2][1][b].p31})`}</p>
                            </div>
                        </label>
                    </div>
                );
            }
            // Total credit
            let Sum3 = 0;
            for (let a = 0; a < semester[2][1].length; a++) {
                Sum3 = Sum3 + semester[2][1][a].Krdt;
            }
            TotalScore3.push(
                <div className="Total_Score_M">
                    <p >Сумма зарегистрированных кредитов</p>
                    <p>{Sum3} </p>
                </div>
            );
        }

        if (semester[3]) {
            // semester name
            ScoreSemester4.push(
                <div className="Score_Sem_M">
                    <p>{semester[3][1][0].p43}</p>
                </div>
            );
            // discipline info
            for (let b = 0; b < semester[3][1].length; b++) {
                ScoreData4.push(
                    <div>
                        <label className="M_Scores"
                            onClick={() => this.markEst(
                                semester[3][1][b].id_a_year,
                                semester[3][0],
                                semester[3][1][b].id_discipline,
                                semester[3][1][b].Krdt,
                                semester[3][1][b].id_student,
                                semester[3][1][b].id_group,
                                semester[3][1][b],
                            )}
                        >
                            <p >
                                {semester[3][1][b].p34}
                                <br />
                                <span>{`[${semester[3][1][b].Krdt} кр.] (${semester[3][1][b].p30} - ${semester[3][1][b].p36})`}</span>
                            </p>
                            <div>
                                <p className="Ball">{`${semester[3][1][b].ball} (${semester[3][1][b].p31})`}</p>
                            </div>
                        </label>
                    </div>
                );
            }
            // Total credit
            let Sum4 = 0;
            for (let a = 0; a < semester[3][1].length; a++) {
                Sum4 = Sum4 + semester[3][1][a].Krdt;
            }
            TotalScore4.push(
                <div className="Total_Score_M">
                    <p >Сумма зарегистрированных кредитов</p>
                    <p>{Sum4} </p>
                </div>
            );
        }
        this.setState({ ScoreSemester1 });
        this.setState({ ScoreData1 });
        this.setState({ TotalScore1 });

        this.setState({ ScoreSemester2 });
        this.setState({ ScoreData2 });
        this.setState({ TotalScore2 });

        this.setState({ ScoreSemester3 });
        this.setState({ ScoreData3 });
        this.setState({ TotalScore3 });

        this.setState({ ScoreSemester4 });
        this.setState({ ScoreData4 });
        this.setState({ TotalScore4 });
    }

    render() {
        if (!this.state.SCORE) {
            return null;
        }

        return (
            <div className="ScoreM">
                <div className="Select_YearM">
                    <select onChange={this.handleChange}>
                        {
                            this.state.SCORE.map((year, index) => {
                                return (
                                    <option
                                        data-id={index}
                                        selected={year[0] == this.props.YEAR}>
                                        {year[1][0].p32} учебный год
                                    </option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="Score_tableM">
                    {this.state.showMark && this.showMarkModal()}
                    {this.state.ScoreSemester1}
                    {this.state.ScoreData1}
                    {this.state.TotalScore1}
                    {this.state.ScoreSemester2}
                    {this.state.ScoreData2}
                    {this.state.TotalScore2}
                    {this.state.ScoreSemester3}
                    {this.state.ScoreData3}
                    {this.state.TotalScore3}
                    {this.state.ScoreSemester4}
                    {this.state.ScoreData4}
                    {this.state.TotalScore4}
                </div>
            </div>
        );
    }
}
